module.exports = __webpack_public_path__ + "img/center_center.5597e044.svg";